module.exports = __webpack_public_path__ + "img/user-1.08c11d77.jpg";